module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "clear": "both",
      "text-align": "left"
    }
  }, [_c('edit-pane', {
    ref: "step2",
    on: {
      "save": _vm.onSave,
      "cancel": _vm.onCancel,
      "edit": _vm.onEdit
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "prgStep2",
    attrs: {
      "label-position": "top"
    },
    model: {
      value: (_vm.intApp),
      callback: function($$v) {
        _vm.intApp = $$v
      },
      expression: "intApp"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('select-action-status', {
    attrs: {
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.step.status),
      callback: function($$v) {
        _vm.$set(_vm.step, "status", $$v)
      },
      expression: "step.status"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('select-priority', {
    attrs: {
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.step.priority),
      callback: function($$v) {
        _vm.$set(_vm.step, "priority", $$v)
      },
      expression: "step.priority"
    }
  })], 1)], 1), _vm._v(" "), (_vm.intApp) ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Permit Type",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Permit Type",
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.intApp.permitType),
      callback: function($$v) {
        _vm.$set(_vm.intApp, "permitType", $$v)
      },
      expression: "intApp.permitType"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.intApp) ? _c('el-col', {
    attrs: {
      "span": 4,
      "offset": 1
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Land Status",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Land Status",
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.intApp.landStatus),
      callback: function($$v) {
        _vm.$set(_vm.intApp, "landStatus", $$v)
      },
      expression: "intApp.landStatus"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.intApp) ? _c('el-col', {
    attrs: {
      "span": 6,
      "offset": 1
    }
  }, [_c('select-authority', {
    attrs: {
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.intApp.authority),
      callback: function($$v) {
        _vm.$set(_vm.intApp, "authority", $$v)
      },
      expression: "intApp.authority"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.intApp) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('select-users', {
    attrs: {
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.intApp.updated_by),
      callback: function($$v) {
        _vm.$set(_vm.intApp, "updated_by", $$v)
      },
      expression: "intApp.updated_by"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('h3', [_vm._v("Fee Types")])]), _vm._v(" "), (_vm.intApp) ? _c('div', _vm._l((_vm.intApp.fees), function(fee, index) {
    return _c('div', {
      key: fee.name
    }, [_c('el-row', [_c('h4', [_vm._v(_vm._s(fee.name))])]), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 16
      }
    }, [_c('el-col', {
      attrs: {
        "sm": 24,
        "md": 12,
        "lg": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "label-width": _vm.labelWidth
      }
    }, [_c('text-input', {
      attrs: {
        "id": 'amnt' + index,
        "type": "number",
        "placeholder": fee.name + ' Amount',
        "disabled": _vm.dis
      },
      model: {
        value: (fee.amount),
        callback: function($$v) {
          _vm.$set(fee, "amount", $$v)
        },
        expression: "fee.amount"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "sm": 24,
        "md": 12,
        "lg": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "label-width": _vm.labelWidth
      }
    }, [_c('el-input', {
      attrs: {
        "id": 'chq' + index,
        "placeholder": fee.name + ' Cheque #',
        "disabled": _vm.dis
      },
      model: {
        value: (fee.chqNo),
        callback: function($$v) {
          _vm.$set(fee, "chqNo", $$v)
        },
        expression: "fee.chqNo"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "sm": 24,
        "md": 12,
        "lg": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "label-width": _vm.labelWidth
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": _vm.dateFormat,
        "id": 'chqreq' + index,
        "placeholder": fee.name + ' Cheque Received',
        "disabled": _vm.dis
      },
      model: {
        value: (fee.chqDate),
        callback: function($$v) {
          _vm.$set(fee, "chqDate", $$v)
        },
        expression: "fee.chqDate"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "sm": 24,
        "md": 12,
        "lg": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "label-width": _vm.labelWidth
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": _vm.dateFormat,
        "id": 'chqsub' + index,
        "placeholder": fee.name + ' Submitted',
        "disabled": _vm.dis
      },
      model: {
        value: (fee.submittedOn),
        callback: function($$v) {
          _vm.$set(fee, "submittedOn", $$v)
        },
        expression: "fee.submittedOn"
      }
    })], 1)], 1)], 1)], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('el-row', [_c('h3', [_vm._v("Approvals")])]), _vm._v(" "), (_vm.intApp) ? _c('el-row', {
    attrs: {
      "align": "middle",
      "gutter": 16
    }
  }, _vm._l((_vm.intApp.refs), function(ref, index) {
    return _c('el-col', {
      key: ref.name,
      attrs: {
        "sm": 24,
        "md": 8,
        "lg": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": ref.name + ' Ref.'
      }
    }, [_c('el-input', {
      attrs: {
        "id": 'appref' + index,
        "placeholder": ref.name + ' Ref.',
        "disabled": _vm.dis
      },
      model: {
        value: (ref.ref),
        callback: function($$v) {
          _vm.$set(ref, "ref", $$v)
        },
        expression: "ref.ref"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": ref.name + ' Submitted'
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": _vm.dateFormat,
        "id": 'appsub' + index,
        "placeholder": "Submitted",
        "disabled": _vm.dis
      },
      model: {
        value: (ref.submittedOn),
        callback: function($$v) {
          _vm.$set(ref, "submittedOn", $$v)
        },
        expression: "ref.submittedOn"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": ref.name + ' Status'
      }
    }, [_c('el-select', {
      attrs: {
        "format": _vm.dateFormat,
        "id": 'appstat' + index,
        "placeholder": "Status",
        "disabled": _vm.dis
      },
      model: {
        value: (ref.status),
        callback: function($$v) {
          _vm.$set(ref, "status", $$v)
        },
        expression: "ref.status"
      }
    }, _vm._l((_vm.status), function(st) {
      return _c('el-option', {
        key: st.type,
        attrs: {
          "label": st.type,
          "value": st.type
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": ref.name + ' Decision'
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": _vm.dateFormat,
        "id": 'appsd' + index,
        "placeholder": "Status Date",
        "disabled": _vm.dis
      },
      model: {
        value: (ref.statusDate),
        callback: function($$v) {
          _vm.$set(ref, "statusDate", $$v)
        },
        expression: "ref.statusDate"
      }
    })], 1), _vm._v(" "), _c('html-input', {
      attrs: {
        "label": ref.name + ' Remarks',
        "id": 'rem' + index,
        "placeholder": "Remarks",
        "disabled": _vm.dis
      },
      model: {
        value: (ref.remarks),
        callback: function($$v) {
          _vm.$set(ref, "remarks", $$v)
        },
        expression: "ref.remarks"
      }
    })], 1)
  }), 1) : _vm._e()], 1), _vm._v(" "), (_vm.rowData.id) ? _c('files-panel', {
    attrs: {
      "type": "site",
      "id": _vm.rowData.site_id,
      "process": "progress",
      "process-id": _vm.rowData.id,
      "disabled": _vm.dis,
      "max-files": 20
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ebc84a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/progress/ProgressStep2.vue
// module id = 1524
// module chunks = 0